<template>
    <div>
        <md-toolbar class="md-transparent" md-elevation="0">
          <span class="md-title">Menú</span>

          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>
        <md-list>
            <md-list-item>
            <md-icon>dashboard</md-icon>
            <span class="md-list-item-text">
                <router-link to="/dashboard">Monitoreo</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>question_answer</md-icon>
            <span class="md-list-item-text">
                <router-link to="/categories">Temas y Preguntas</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>search</md-icon>
            <span class="md-list-item-text">
                <router-link to="/quests">Quests</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>school</md-icon>
            <span class="md-list-item-text">
                <router-link to="/schools">Establecimientos</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>people</md-icon>
            <span class="md-list-item-text">
                <router-link to="/players">Jugadores</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>playlist_add_check</md-icon>
            <span class="md-list-item-text">
                <router-link to="/playerexports">Reportes de Jugadores</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>format_list_numbered</md-icon>
            <span class="md-list-item-text">
                <router-link to="/rankings">Rankings</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>map</md-icon>
            <span class="md-list-item-text">
                <router-link to="/map">Mapa</router-link>
            </span>
            </md-list-item>

            <md-list-item>
            <md-icon>account_box</md-icon>
            <span class="md-list-item-text">
                <router-link to="/users">Usuarios</router-link>
            </span>
            </md-list-item>

            <md-divider></md-divider>

            <md-list-item>
            <md-icon>exit_to_app</md-icon>
            <span class="md-list-item-text" @click="doLogout">
                <router-link to="/logout">Salir</router-link>
            </span>
            </md-list-item>
        </md-list>
    </div>
</template>

<style lang="scss" scoped>
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
</style>

<script>
import firebase from 'firebase';
import {user} from '../helpers/user'

export default {
    name: 'MENU',
    props: ['menuVisible'],
    data: () => ({
        user: user
    }),
    methods: {
        toggleMenu: function () {
            this.$emit('toggleMenu')
        },
        doLogout: function() {
            firebase.auth().signOut().then(function() {
                console.log('Logout ok!');
            }, function(error) {
                console.log('Logout error!');
                console.log(error);
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Menu.vue